import styled from 'styled-components';

import Menu from '@mindtickle/menu';
import { tokens } from '@mindtickle/styles';

export const StyledHeaderMenuItemGroup = styled(Menu.ItemGroup)<{ $showBottomBorder: boolean }>`
  border-bottom: ${({ $showBottomBorder }) =>
    $showBottomBorder ? `1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY}` : 'none'};
  width: 284px;
  overflow: hidden;
  min-width: 0;

  && .mtdls-menu-item-group-title {
    padding: 0;
    height: unset;
    line-height: unset;
  }

  &:last-child {
    border: none;
  }
`;
